export default "__VITE_ASSET__B8T0P2_m__"